// @mui
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
//
import { IftaFuelLine, IftaMileLine } from 'src/models';

// ----------------------------------------------------------------------

const PREVIEW_LIMIT = 20;

export function MilesPreviewTable({ lines }: { lines: IftaMileLine[] }) {
  return (
    <TableContainer sx={{ maxHeight: 360 }}>
      <Table stickyHeader size="small" data-testid="miles-preview-table">
        <TableHead>
          <TableRow>
            <TableCell>Truck</TableCell>
            <TableCell>State</TableCell>
            <TableCell align="right">Total Miles</TableCell>
            <TableCell align="right">Taxable Miles</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lines.slice(0, PREVIEW_LIMIT).map((line, index) => (
            <TableRow key={index}>
              <TableCell>{line.truckNumber}</TableCell>
              <TableCell>{line.state}</TableCell>
              <TableCell align="right">{line.totalMiles.toLocaleString()}</TableCell>
              <TableCell align="right">{line.taxableMiles.toLocaleString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {lines.length > PREVIEW_LIMIT && (
        <Typography variant="caption" sx={{ p: 1, display: 'block', color: 'text.secondary' }}>
          Showing {PREVIEW_LIMIT} of {lines.length} rows
        </Typography>
      )}
    </TableContainer>
  );
}

export function FuelPreviewTable({ lines }: { lines: IftaFuelLine[] }) {
  return (
    <TableContainer sx={{ maxHeight: 360 }}>
      <Table stickyHeader size="small" data-testid="fuel-preview-table">
        <TableHead>
          <TableRow>
            <TableCell>Truck</TableCell>
            <TableCell>State</TableCell>
            <TableCell align="right">Gallons</TableCell>
            <TableCell align="right">Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lines.slice(0, PREVIEW_LIMIT).map((line, index) => (
            <TableRow key={index}>
              <TableCell>{line.truckNumber}</TableCell>
              <TableCell>{line.state}</TableCell>
              <TableCell align="right">{line.gallons.toLocaleString()}</TableCell>
              <TableCell align="right">${line.amount.toLocaleString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {lines.length > PREVIEW_LIMIT && (
        <Typography variant="caption" sx={{ p: 1, display: 'block', color: 'text.secondary' }}>
          Showing {PREVIEW_LIMIT} of {lines.length} rows
        </Typography>
      )}
    </TableContainer>
  );
}
